import { IconType, Color } from '../Widget.types';
import { StyledIconType } from './IconsType.styles';

const StatusIcon = (color?: Color) => (
  <StyledIconType color={color ?? '#FACC15'}>
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
      <path
        // eslint-disable-next-line max-len
        d="M12.2002 2.125L2.82516 13.375H11.2627L10.3252 20.875L19.7002 9.625H11.2627L12.2002 2.125Z"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledIconType>
);

const WarningIcon = (color?: Color) => (
  <StyledIconType color={color ?? '#4C01A7'}>
    <svg xmlns="http://www.w3.org/2000/svg" width="86" height="87" viewBox="0 0 86 87" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M43.0005 25.0059C53.2148 25.0059 61.4951 33.2862 61.4951 43.5005C61.4951 53.7148 53.2148 61.9951 43.0005 61.9951C32.7862 61.9951 24.5059 53.7148 24.5059 43.5005C24.5059 33.2862 32.7862 25.0059 43.0005 25.0059ZM42.9996 28.7049C34.8281 28.7049 28.2039 35.3292 28.2039 43.5006C28.2039 51.672 34.8281 58.2963 42.9996 58.2963C51.171 58.2963 57.7953 51.672 57.7953 43.5006C57.7953 35.3292 51.171 28.7049 42.9996 28.7049ZM43.0005 50.8984C44.0219 50.8984 44.8499 51.7265 44.8499 52.7479C44.8499 53.7693 44.0219 54.5974 43.0005 54.5974C41.9791 54.5974 41.151 53.7693 41.151 52.7479C41.151 51.7265 41.9791 50.8984 43.0005 50.8984ZM43.0005 32.4036C44.0219 32.4036 44.8499 33.2316 44.8499 34.2531V45.3498C44.8499 46.3713 44.0219 47.1993 43.0005 47.1993C41.9791 47.1993 41.151 46.3713 41.151 45.3498V34.2531C41.151 33.2316 41.9791 32.4036 43.0005 32.4036Z"
        fill="white"
      />
    </svg>
  </StyledIconType>
);

const TimeIcon = (color?: Color) => (
  <StyledIconType color={color ?? '#EF4444'}>
    <svg xmlns="http://www.w3.org/2000/svg" width="87" height="86" viewBox="0 0 87 86" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M25.7214 30.5953L31.2698 25.0469C31.992 24.3247 33.163 24.3247 33.8853 25.0469C34.6076 25.7692 34.6076 26.9402 33.8853 27.6625L28.3369 33.2109C27.6147 33.9331 26.4436 33.9331 25.7214 33.2109C24.9991 32.4886 24.9991 31.3176 25.7214 30.5953ZM56.0784 25.0469L61.6268 30.5953C62.349 31.3176 62.349 32.4886 61.6268 33.2109C60.9045 33.9331 59.7335 33.9331 59.0113 33.2109L53.4629 27.6625C52.7406 26.9402 52.7406 25.7692 53.4629 25.0469C54.1851 24.3247 55.3561 24.3247 56.0784 25.0469ZM43.673 61.4942C52.8658 61.4942 60.3181 54.0419 60.3181 44.849C60.3181 35.6562 52.8658 28.2039 43.673 28.2039C34.4801 28.2039 27.0278 35.6562 27.0278 44.849C27.0278 54.0419 34.4801 61.4942 43.673 61.4942ZM43.6734 57.7951C36.5234 57.7951 30.7272 51.9988 30.7272 44.8488C30.7272 37.6988 36.5234 31.9026 43.6734 31.9026C50.8234 31.9026 56.6197 37.6988 56.6197 44.8488C56.6197 51.9988 50.8234 57.7951 43.6734 57.7951ZM43.6737 35.6021C44.6951 35.6021 45.5232 36.4301 45.5232 37.4515V42.2338L48.6804 45.3911C49.4027 46.1133 49.4027 47.2843 48.6804 48.0066C47.9581 48.7289 46.7871 48.7289 46.0649 48.0066L42.3659 44.3077C42.0191 43.9608 41.8242 43.4904 41.8242 42.9999V37.4515C41.8242 36.4301 42.6523 35.6021 43.6737 35.6021Z"
        fill="white"
      />
    </svg>
  </StyledIconType>
);

export const IconsType = (type: IconType, color?: Color) => {
  switch (type) {
    case 'status':
      return StatusIcon(color);
    case 'warning':
      return WarningIcon(color);
    case 'time':
      return TimeIcon(color);
    default:
      return StatusIcon(color);
  }
};
